export default "__VITE_ASSET__BMpo8ea7__"